export var XHR_SENDER_TYPE = "rpldy-sender";